import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Self, computed, input } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { FormControlPipe } from '@shared/pipe';
import { IFormCustomClass } from '@data/schema';

@Component({
    selector: 'app-date-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, BsDatepickerModule, FormControlPipe],
    templateUrl: './date-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateInputComponent implements ControlValueAccessor {
    label = input.required<string>();
    placeholder = input<string>('Select a date');
    minDate = input<Date>();
    maxDate = input<Date>();
    inputRequiredIndicatorEnabled = input<boolean>(false);
    testAutomationSelectorName = input<string>();
    minMode = input<'day' | 'month' | 'year'>('day');
    customClasses = input<IFormCustomClass>({
        formGroup: 'mb-3',
        label: 'form-label fw-medium mb-2',
        input: '',
    });

    private _onTouched: () => void = () => {};

    readonly bsConfig = computed<Partial<BsDatepickerConfig>>(() => ({
        dateInputFormat: this.minMode() === 'year' ? 'YYYY' : 'DD MMM YYYY',
        minMode: this.minMode(),
        containerClass: 'theme-souk',
        showWeekNumbers: false,
        adaptivePosition: true,
        returnFocusToInput: true,
    }));

    constructor(@Self() public ngControl: NgControl) {
        this.ngControl.valueAccessor = this;
    }

    // The formControl binding handles reading; writing is direct via control.setValue.
    writeValue(_obj: any): void {}
    registerOnChange(_fn: any): void {}
    registerOnTouched(fn: () => void): void {
        this._onTouched = fn;
    }

    onValueChange(value: Date): void {
        this.ngControl.control?.setValue(value);
        this._onTouched();
    }

    onInputBlur(): void {
        this._onTouched();
    }
}
